import DOMPurify from 'dompurify';

// FORBID_TAGS over WHOLE_DOCUMENT: the flag returns documentElement.outerHTML, so a head-hoisted <style>
// survives into the div and restyles the whole page. A <style> placed after text is not hoisted, so the
// default config keeps it too — both positions need the explicit forbid.
export const getSanitizedRichTextHtml = value => ({
  __html: DOMPurify.sanitize(value, { FORBID_TAGS: ['style'] }),
});
